<template>
	<div>
		<div class="grid-100 grid-parent">
			<div class="video-item grid-100 grid-parent">
				<div class="video-header grid-100 grid-parent">
					<div class="video">
						<iframe id="main-video" src="https://player.vimeo.com/video/229538519" width="640" height="352" frameborder="0" webkitallowfullscreen
							mozallowfullscreen allowfullscreen></iframe>
					</div>
				</div>
				<h4>Brain Dump Free Episode: Fridge Terror</h4>
			</div>
		</div>

		<div class="grid-100 grid-parent">
			<div class="grid-48 grid-parent">
				<div class="video-item grid-100 grid-parent">
					<div class="video-header grid-100 grid-parent">
						<div class="video">
							<iframe src="https://player.vimeo.com/video/235354279" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen
								allowfullscreen></iframe>
						</div>
					</div>
					<h4>Brain Dump: Episode 1 : Tiny Toaster</h4>
					<!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
            <a target="_blank" href="https://vimeo.com//store/ondemand/buy/120415/229698811?popup=true&r=">
						<div class="buy-cta white">
							<span class="price">£3.50</span>
						</div>
					</a>
					<a target="_blank" href="https://vimeo.com/ondemand/rossnoble">
						<div class="buy-cta all white">
							<span class="price">All Videos</span>
						</div>
					</a>
				</div>
			</div>
			<div class="grid-48 grid-parent margin-left-4">
				<div class="video-item grid-100 grid-parent">
					<div class="video-header grid-100 grid-parent">
						<div class="video">
							<iframe src="https://player.vimeo.com/video/229698465" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen
								allowfullscreen></iframe>
						</div>
					</div>
					<h4>Brain Dump: Episode 2: Pogo Donkey</h4>
					<!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
            <a target="_blank" href="https://vimeo.com//store/ondemand/buy/120415/229687750?popup=true&r=">
						<div class="buy-cta white">
							<span class="price">£3.50</span>
						</div>
					</a>
					<a target="_blank" href="https://vimeo.com/ondemand/rossnoble">
						<div class="buy-cta all white">
							<span class="price">All Videos</span>
						</div>
					</a>
				</div>
			</div>
		</div>

		<div class="grid-100 grid-parent">
			<div class="grid-48 grid-parent">
				<div class="video-item grid-100 grid-parent">
					<div class="video-header grid-100 grid-parent">
						<div class="video">
							<iframe src="https://player.vimeo.com/video/229698526" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen
								allowfullscreen></iframe>
						</div>
					</div>
					<h4>Brain Dump: Episode 3: Mouse Jamboree</h4>
					<!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
            <a target="_blank" href="https://vimeo.com//store/ondemand/buy/120415/229689650?popup=true&r=">
						<div class="buy-cta white">
							<span class="price">£3.50</span>
						</div>
					</a>
					<a target="_blank" href="https://vimeo.com/ondemand/rossnoble">
						<div class="buy-cta all white">
							<span class="price">All Videos</span>
						</div>
					</a>
				</div>
			</div>
			<div class="grid-48 grid-parent margin-left-4">
				<div class="video-item grid-100 grid-parent">
					<div class="video-header grid-100 grid-parent">
						<div class="video">
							<iframe src="https://player.vimeo.com/video/229698719" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen
								allowfullscreen></iframe>
						</div>
					</div>
					<h4>Brain Dump: Episode 4: Drunk Scalextric</h4>
					<!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
            <a target="_blank" href="https://vimeo.com//store/ondemand/buy/120415/229692537?popup=true&r=">
						<div class="buy-cta white">
							<span class="price">£3.50</span>
						</div>
					</a>
					<a target="_blank" href="https://vimeo.com/ondemand/rossnoble">
						<div class="buy-cta all white">
							<span class="price">All Videos</span>
						</div>
					</a>
				</div>
			</div>
		</div>

		<div class="grid-100 grid-parent">
			<div class="grid-48 grid-parent">
				<div class="video-item grid-100 grid-parent">
					<div class="video-header grid-100 grid-parent">
						<div class="video">
							<iframe src="https://player.vimeo.com/video/229698662" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen
								allowfullscreen></iframe>
						</div>
					</div>
					<h4>Brain Dump: Episode 5 : Aggressive Twiddling</h4>
					<!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
            <a target="_blank" href="https://vimeo.com//store/ondemand/buy/120415/229694282?popup=true&r=">
						<div class="buy-cta white">
							<span class="price">£3.50</span>
						</div>
					</a>
					<a target="_blank" href="https://vimeo.com/ondemand/rossnoble">
						<div class="buy-cta all white">
							<span class="price">All Videos</span>
						</div>
					</a>
				</div>
			</div>
			<div class="grid-48 grid-parent margin-left-4">
				<div class="video-item grid-100 grid-parent">
					<div class="video-header grid-100 grid-parent">
						<div class="video">
							<iframe src="https://player.vimeo.com/video/229698428" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen
								allowfullscreen></iframe>
						</div>
					</div>
					<h4> Brain Dump: Episode 6 : Harpsichord</h4>
					<!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
            <a target="_blank" href="https://vimeo.com//store/ondemand/buy/120415/229696148?popup=true&r=">
						<div class="buy-cta white">
							<span class="price">£3.50</span>
						</div>
					</a>
					<a target="_blank" href="https://vimeo.com/ondemand/rossnoble">
						<div class="buy-cta all white">
							<span class="price">All Videos</span>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

	<script>
		export default {
			name: "OnDemandOriginal"
}
</script>


// WEBPACK FOOTER //
// OriginalContent.vue?adc7bffe